import axios from 'axios';

const API = axios.create({
    // 🌟 CORRECTED SPELLING: sherain_project
    baseURL: 'https://sherianalumni.com/api/',
});

export default API;